var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_DGB 1",
    clipPath: "url(#clip0_1736_9991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9562 0.012652C5.33599 0.311096 0.211098 5.91999 0.512654 12.5415C0.81421 19.1631 6.42177 24.2853 13.0429 23.9875C19.664 23.6898 24.788 18.0764 24.4873 11.4567C24.1867 4.83687 18.5787 -0.288904 11.9562 0.012652Z",
    fill: "#0035B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.8527 14.0037C15.1558 13.7757 19.556 12.8721 19.0132 10.3612C18.8183 9.46077 17.8918 8.47011 16.4945 7.78122C15.3772 7.27877 14.014 6.98633 12.4827 6.98633C8.23627 6.98633 5.28271 9.23077 5.28271 12.0001C5.28271 13.9281 6.71649 15.6001 9.0216 16.4401C9.51072 15.1528 11.458 14.4188 13.8527 14.0037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5102 14.8913C10.6057 15.1313 9.73241 15.7451 9.17041 16.4924C10.1411 16.8246 11.2575 17.0113 12.4815 17.0113C16.7286 17.0113 19.6815 14.7669 19.6815 11.9997C19.6815 11.758 19.6587 11.5168 19.6133 11.2793C19.4731 14.5273 14.5935 14.6324 12.5102 14.8913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.38445 9.38281H6.96045L6.97712 9.4237C7.04045 9.57726 7.03667 9.8557 7.03245 10.1053C7.03245 10.1637 7.03 13.3941 7.03 13.3941H7.05823C7.06489 13.3941 7.70734 13.4164 8.31578 13.4164C9.58778 13.4164 10.4427 12.5524 10.4427 11.271C10.4427 10.1244 9.63534 9.38281 8.38445 9.38281ZM7.64045 9.74415C7.72312 9.73748 7.97645 9.71926 8.15556 9.71926C9.24334 9.71926 9.75 10.2473 9.75 11.3781C9.75 12.5479 9.29978 13.1173 8.37356 13.1173C7.69578 13.1173 7.64023 13.0846 7.64023 12.6824L7.64045 9.74415Z",
    fill: "#0035B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.2659 13.3675C14.2437 13.1317 14.2355 12.9715 14.2355 12.8341V11.4297H13.5592L13.5815 11.4728C13.5815 11.4728 13.6501 11.6086 13.6501 11.9048C13.6501 11.9144 13.6526 12.8806 13.6257 13.1097C13.4538 13.1481 13.2782 13.1673 13.1021 13.1668C12.0283 13.1668 11.4835 12.5499 11.4835 11.3355C11.4835 10.4081 12.097 9.71659 12.9743 9.65259C13.4361 9.61948 13.8801 9.74526 14.1603 9.98859L14.2083 10.0315V9.46126L14.1861 9.45681C13.8815 9.39064 13.5713 9.35343 13.2597 9.3457C11.7135 9.3457 10.791 10.1617 10.791 11.5219C10.791 12.973 11.9181 13.4899 12.973 13.4899C13.3976 13.4917 13.8218 13.4608 14.2417 13.3977L14.2686 13.3935L14.2659 13.3675Z",
    fill: "#0035B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.6803 11.1917C17.0672 11.0886 17.4378 10.7473 17.4378 10.2495C17.4378 9.70659 16.9476 9.38281 16.1267 9.38281H14.9092L14.9174 9.41881C14.9174 9.41881 14.9534 9.58015 14.9534 9.95015V13.4275H14.9836C14.9878 13.4275 15.4636 13.4179 16.0503 13.4179C17.0745 13.4179 17.6612 12.9735 17.6612 12.1981C17.6605 11.7181 17.2636 11.3166 16.6803 11.1917ZM15.561 11.3866H15.8754C16.6016 11.3866 16.9687 11.6717 16.9687 12.2337C16.9687 12.8266 16.6521 13.115 16.0003 13.115C15.6843 13.115 15.561 13.0008 15.561 12.7079V11.3866ZM15.5634 9.6977H15.9614C16.5876 9.6977 16.8545 9.88726 16.8545 10.3313C16.8545 10.8368 16.5263 11.0719 15.8207 11.0719H15.561L15.5634 9.6977Z",
    fill: "#0035B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_9991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDgb);
export default __webpack_public_path__ + "static/media/dgb.4c4f08244a7b943798025a1d312175e2.svg";
export { ForwardRef as ReactComponent };